export default __webpack_public_path__ + "static/media/github.0b3aeba9.svg";